import type { DropdownData, DropdownSelection } from '../interfaces/input.interface';

const dropdownSelectionStore = new WeakMap<DropdownData<unknown>, DropdownSelection<unknown>>();

export function getDropdownSelected<T>(dropdown: DropdownData<T>): DropdownSelection<T> {
    return (dropdownSelectionStore.get(dropdown as DropdownData<unknown>) ?? null) as DropdownSelection<T>;
}

export function getDropdownSelectedArray<T>(dropdown: DropdownData<T>): T[] {
    const selected = getDropdownSelected(dropdown);

    if (selected === null) {
        return [];
    }

    return Array.isArray(selected) ? selected : [selected];
}

export function getDropdownSelectedSingle<T>(dropdown: DropdownData<T>): T | null {
    const selected = getDropdownSelected(dropdown);

    if (selected === null || Array.isArray(selected)) {
        return null;
    }

    return selected;
}

export function setDropdownSelected<T>(
    dropdown: DropdownData<T>,
    selected: DropdownSelection<T>
): void {
    dropdownSelectionStore.set(dropdown as DropdownData<unknown>, selected as DropdownSelection<unknown>);
}

export function clearDropdownSelected<T>(dropdown: DropdownData<T>): void {
    setDropdownSelected(dropdown, null);
}

export function setDropdownSelectedFromArray<T>(
    dropdown: DropdownData<T>,
    selected: T[],
    multiple: boolean
): void {
    setDropdownSelected(
        dropdown,
        multiple ? selected : selected[0] ?? null
    );
}
